define("checkout/components/seamless-checkout-table/line-item", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <tr data-test-id={{@testId}} data-test-value={{@count}}>
    <td class="u--p__l__md {{@titleQaClass}}">
      {{@title}}
  
      {{#if @subtitle}}
        <br />
        <span class="u--text--light">
          {{@subtitle}}
        </span>
      {{/if}}
    </td>
    <td class="u--text--center {{@countQaClass}}">{{@count}}</td>
    {{#if @cost}}
      <td class="u--text--right" data-test-id={{concat @testId "-cost"}}>{{format-currency @cost}}</td>
    {{/if}}
  </tr>
  */
  {
    "id": "3y65qDSz",
    "block": "[[[10,\"tr\"],[15,\"data-test-id\",[30,1]],[15,\"data-test-value\",[30,2]],[12],[1,\"\\n  \"],[10,\"td\"],[15,0,[29,[\"u--p__l__md \",[30,3]]]],[12],[1,\"\\n    \"],[1,[30,4]],[1,\"\\n\\n\"],[41,[30,5],[[[1,\"      \"],[10,\"br\"],[12],[13],[1,\"\\n      \"],[10,1],[14,0,\"u--text--light\"],[12],[1,\"\\n        \"],[1,[30,5]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n  \"],[10,\"td\"],[15,0,[29,[\"u--text--center \",[30,6]]]],[12],[1,[30,2]],[13],[1,\"\\n\"],[41,[30,7],[[[1,\"    \"],[10,\"td\"],[14,0,\"u--text--right\"],[15,\"data-test-id\",[28,[37,1],[[30,1],\"-cost\"],null]],[12],[1,[28,[35,2],[[30,7]],null]],[13],[1,\"\\n\"]],[]],null],[13]],[\"@testId\",\"@count\",\"@titleQaClass\",\"@title\",\"@subtitle\",\"@countQaClass\",\"@cost\"],false,[\"if\",\"concat\",\"format-currency\"]]",
    "moduleName": "checkout/components/seamless-checkout-table/line-item.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});